import { render, staticRenderFns } from "./SelectedReportDownload.vue?vue&type=template&id=be71ba38&"
import script from "./SelectedReportDownload.vue?vue&type=script&lang=js&"
export * from "./SelectedReportDownload.vue?vue&type=script&lang=js&"
import style0 from "./SelectedReportDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports